/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseObjectType from './BaseObjectType';
import PropertySetter from './PropertySetter';
import MoserObjectUtils from './MoserObjectUtils';
import EditModeType from './EditModeType';
import MoserObject from './MoserObject';
import TransientSourceType from './TransientSourceType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (runtime) // updateModuleReference
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForPropertyType, updateShortcutAddAt, updateShortcutRemoveAt, updateShortcutSet
//@import com/ibm/bi/platform/moser/common/generated/metadata/EditModeType (runtime) // new, EditModeType
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/TransientSourceType (runtime) // new

/**
 * The base metadata object. <p>Java class for objectType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="objectType"&gt; &lt;complexContent&gt; &lt;extension base="{}baseObjectType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="description" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="label" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="comment" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="screenTip" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="hidden" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="propertyOverride" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="editMode" type="{}editModeType" minOccurs="0"/&gt; &lt;element name="originalDescription" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="originalLabel" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="originalScreenTip" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="transientSource" type="{}transientSourceType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ObjectType extends BaseObjectType{

	identifier = null;

	description = null;

	label = null;

	comment = null;

	screenTip = null;

	hidden = null;

	propertyOverride = null;

	editMode = null;

	originalDescription = null;

	originalLabel = null;

	originalScreenTip = null;

	transientSource = null;



	/**
	 * Gets the value of the identifier property.
	 * @return {String} possible object is {@link String}
	 */
	getIdentifier() {
		return this.identifier;
	}

	/**
	 * Sets the value of the identifier property.
	 * @param {String} value allowed object is {@link String}
	 */
	setIdentifier(value) {
		var oldValue = this.identifier;
		this.identifier = value;
		this._setAndNotify(91, oldValue, value, false, true);
		PropertySetter.updateModuleReference(this, oldValue, value);
		MoserObjectUtils.updateShortcutSet(this, 91, oldValue, value);
	}

	/**
	 * Gets the value of the description property.
	 * @return {String} possible object is {@link String}
	 */
	getDescription() {
		return this.description;
	}

	/**
	 * Sets the value of the description property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDescription(value) {
		var oldValue = this.description;
		this.description = value;
		this._setAndNotify(126, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 126, oldValue, value);
	}

	/**
	 * Gets the value of the label property.
	 * @return {String} possible object is {@link String}
	 */
	getLabel() {
		return this.label;
	}

	/**
	 * Sets the value of the label property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLabel(value) {
		var oldValue = this.label;
		this.label = value;
		this._setAndNotify(157, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 157, oldValue, value);
	}

	/**
	 * Gets the value of the comment property.
	 * @return {String} possible object is {@link String}
	 */
	getComment() {
		return this.comment;
	}

	/**
	 * Sets the value of the comment property.
	 * @param {String} value allowed object is {@link String}
	 */
	setComment(value) {
		var oldValue = this.comment;
		this.comment = value;
		this._setAndNotify(158, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 158, oldValue, value);
	}

	/**
	 * Gets the value of the screenTip property.
	 * @return {String} possible object is {@link String}
	 */
	getScreenTip() {
		return this.screenTip;
	}

	/**
	 * Sets the value of the screenTip property.
	 * @param {String} value allowed object is {@link String}
	 */
	setScreenTip(value) {
		var oldValue = this.screenTip;
		this.screenTip = value;
		this._setAndNotify(159, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 159, oldValue, value);
	}

	/**
	 * Gets the value of the hidden property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isHidden() {
		return this.hidden;
	}

	/**
	 * Sets the value of the hidden property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setHidden(value) {
		var oldValue = this.hidden;
		this.hidden = value;
		this._setAndNotify(127, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 127, oldValue, value);
	}

	/**
	 * Gets the value of the propertyOverride property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the propertyOverride property. <p> For example, to add a new item, do as follows: <pre> getPropertyOverride().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getPropertyOverride() {
		if (!this.propertyOverride) {
			this.propertyOverride = [];
		}
		return this.propertyOverride;
	}

	/**
	 * Gets the value of the editMode property.
	 * @return {EditModeType} possible object is {@link EditModeType}
	 */
	getEditMode() {
		if (!this.editMode) {
			return (EditModeType.RW);
		}
		return this.editMode;
	}

	/**
	 * Sets the value of the editMode property.
	 * @param {EditModeType} value allowed object is {@link EditModeType}
	 */
	setEditMode(value) {
		var oldValue = this.editMode;
		this.editMode = value;
		this._setAndNotify(161, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the originalDescription property.
	 * @return {String} possible object is {@link String}
	 */
	getOriginalDescription() {
		return this.originalDescription;
	}

	/**
	 * Sets the value of the originalDescription property.
	 * @param {String} value allowed object is {@link String}
	 */
	setOriginalDescription(value) {
		var oldValue = this.originalDescription;
		this.originalDescription = value;
		this._setAndNotify(162, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the originalLabel property.
	 * @return {String} possible object is {@link String}
	 */
	getOriginalLabel() {
		return this.originalLabel;
	}

	/**
	 * Sets the value of the originalLabel property.
	 * @param {String} value allowed object is {@link String}
	 */
	setOriginalLabel(value) {
		var oldValue = this.originalLabel;
		this.originalLabel = value;
		this._setAndNotify(163, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the originalScreenTip property.
	 * @return {String} possible object is {@link String}
	 */
	getOriginalScreenTip() {
		return this.originalScreenTip;
	}

	/**
	 * Sets the value of the originalScreenTip property.
	 * @param {String} value allowed object is {@link String}
	 */
	setOriginalScreenTip(value) {
		var oldValue = this.originalScreenTip;
		this.originalScreenTip = value;
		this._setAndNotify(164, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the transientSource property.
	 * @return {TransientSourceType} possible object is {@link TransientSourceType}
	 */
	getTransientSource() {
		return this.transientSource;
	}

	/**
	 * Sets the value of the transientSource property.
	 * @param {TransientSourceType} value allowed object is {@link TransientSourceType}
	 */
	setTransientSource(value) {
		var oldValue = this.transientSource;
		this.transientSource = value;
		this._setAndNotify(165, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the <code>propertyOverride</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetPropertyOverride() {
		return this.propertyOverride;
	}

	/**
	 * True if this object is imported
	 */
	isImported() {
		if (this.propertyOverride) {
			if (this.propertyOverride.indexOf("Imported")> -1) {
				return true;
			}
			if (this.propertyOverride.indexOf("NEW")> -1) {
				return false;
			}
		}
		var obj = this._parent;
		while (obj) {
			if (("QuerySubject" == obj.getObjectType() || "Folder" == obj.getObjectType()) || "FolderType" == obj.getObjectType()) {
				var parentOverrides = (obj).basicGetPropertyOverride();
				if (parentOverrides) {
					if (parentOverrides.indexOf("Imported")> -1) {
						return true;
					}
					if (parentOverrides.indexOf("NEW")> -1) {
						return false;
					}
				}
			}
			obj = obj.getParent();
		}
		return false;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addPropertyAt(position, item) {
		this._addAtAndNotify(this.getProperty(), position, item, 96, true, false);
		MoserObjectUtils.propertyOverrideForPropertyType(this, item);
		MoserObjectUtils.updateShortcutAddAt(this, 96, position, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removePropertyAt(position) {
		MoserObjectUtils.updateShortcutRemoveAt(this, 96, position);
		this._removeAtAndNotify(this.getProperty(), position, 96, true);
	}

	/**
	 * Creates a new instance of <code>ObjectType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ObjectType</code> object from.
	 * @return {ObjectType} an object of type <code>ObjectType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createObjectType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addPropertyOverrideAt(position, item) {
		var overrideList = this.getPropertyOverride();
		for (var i = 0; (i < overrideList.length); ++i) {
			var override = overrideList[i];
			if (override == item) {
				return;
			}
		}
		this._addAtAndNotify(this.getPropertyOverride(), position, item, 160, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addPropertyOverride(item) {
		this.addPropertyOverrideAt(this.getPropertyOverride().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removePropertyOverrideAt(position) {
		this._removeAtAndNotify(this.getPropertyOverride(), position, 160, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removePropertyOverride(item) {
		var i = this.getPropertyOverride().indexOf(item);
		if (i >= 0) {
			this.removePropertyOverrideAt(i);
		}
	}

	basicGetEditMode() {
		return this.editMode;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ObjectType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 91, "identifier", null));
		featureList.push(this.createFeature(false, false, false, 126, "description", null));
		featureList.push(this.createFeature(false, false, false, 157, "label", null));
		featureList.push(this.createFeature(false, false, false, 158, "comment", null));
		featureList.push(this.createFeature(false, false, false, 159, "screenTip", null));
		featureList.push(this.createFeature(false, false, false, 127, "hidden", null));
		featureList.push(this.createFeature(true, false, false, 160, "propertyOverride", null));
		featureList.push(this.createFeature(false, true, false, 161, "editMode", EditModeType));
		featureList.push(this.createFeature(false, false, false, 162, "originalDescription", null));
		featureList.push(this.createFeature(false, false, false, 163, "originalLabel", null));
		featureList.push(this.createFeature(false, false, false, 164, "originalScreenTip", null));
		featureList.push(this.createFeature(false, true, false, 165, "transientSource", TransientSourceType));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 91:
			this.setIdentifier((value));
			break;
		case 126:
			this.setDescription((value));
			break;
		case 157:
			this.setLabel((value));
			break;
		case 158:
			this.setComment((value));
			break;
		case 159:
			this.setScreenTip((value));
			break;
		case 127:
			this.setHidden((value));
			break;
		case 161:
			this.setEditMode((value));
			break;
		case 162:
			this.setOriginalDescription((value));
			break;
		case 163:
			this.setOriginalLabel((value));
			break;
		case 164:
			this.setOriginalScreenTip((value));
			break;
		case 165:
			this.setTransientSource((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 160:
			this.propertyOverride = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 91:
			return this.getIdentifier();
		case 126:
			return this.getDescription();
		case 157:
			return this.getLabel();
		case 158:
			return this.getComment();
		case 159:
			return this.getScreenTip();
		case 127:
			return this.isHidden();
		case 160:
			return this.getPropertyOverride();
		case 161:
			return this.getEditMode();
		case 162:
			return this.getOriginalDescription();
		case 163:
			return this.getOriginalLabel();
		case 164:
			return this.getOriginalScreenTip();
		case 165:
			return this.getTransientSource();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 91:
			return this.getIdentifier();
		case 126:
			return this.getDescription();
		case 157:
			return this.getLabel();
		case 158:
			return this.getComment();
		case 159:
			return this.getScreenTip();
		case 127:
			return this.isHidden();
		case 160:
			return this.basicGetPropertyOverride();
		case 161:
			return this.basicGetEditMode();
		case 162:
			return this.getOriginalDescription();
		case 163:
			return this.getOriginalLabel();
		case 164:
			return this.getOriginalScreenTip();
		case 165:
			return this.getTransientSource();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 160:
			this.addPropertyOverrideAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 160:
			this.addPropertyOverride((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 160:
			this.removePropertyOverrideAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 160:
			this.removePropertyOverride((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ObjectType.js